import { useReducer, useEffect, useState, useContext } from 'react';
import { useApolloClient } from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';
import getConfig from 'next/config';
import BroadbandContainer from '../../../components/eir-broadband/BroadbandContainer';
import NotificationBanner from '../../../components/eir-notification-banner/NotificationBanner';
import BroadbandContext, {
  defaultState,
  reducer,
} from '../../../components/eir-broadband/BroadbandContext.context';
import { displayCart } from '../../../components/eir-cart/cart.util';
import RootContext from '../../../../util/root.context';
import getStrapiData from '../../../integration/strapi';
import LoginModal from '../../../components/eir-login/LoginModal';
import validateCart from '../../../components/shared/validateCart';
import ErrorModal from '../../../components/eir-error-modal/ErrorModal';
import {
  setCookie,
  getAllCookies,
  getCookie,
  getTokenFromCookies,
  removeCookie,
  clearAllCookies,
} from '../../../hooks/useCookie';
import { useToggle } from '../../../hooks/useToggle';
import { changeOfferRequest } from '../../../integration/change-offer.api';
import { eligibilityCheck } from '../../../components/shared/eligibilityCheck';
import { getCrossSellEligiblity, getJourneyDetails } from '../../../integration/eligibility.api';
import SubscriptionSelectionModal from '../../../components/eir-change-offer/SubscriptionSelectionModal';
import {
  setCode,
  clearLocalStorage,
  removeLocalStorage,
  setLocalStorage,
  getLocalStorage,
} from '../../../hooks/useLocalStorage';
import NoEligibilityErrorModal from '../../../components/eir-error-modal/NoEligibilityErrorModal';
import NavBar from '../../../components/eir-nav-bar/NavBar';
import NavBarTitle from '../../../components/eir-nav-bar/NavBarTitle';
import DropDownMenu from '../../../components/eir-dropdown-menu/DropDownMenu';
import EirAbondonJourney from '../../../components/eir-abondon-journey-modal/EirAbondonJourney';
import { getCOPrequalDetailsByID } from '../../../integration/prequal.api';
import { formatAddress, removeTariff } from '../../../components/eir-broadband/Broadband.util';
import EirWebchatModal from '../../../components/eir-broadband/EirWebchatModal';
import EirPrepayModal from '../../../components/eir-broadband/EirPrepayModal';
import EirRegistrationRequiredModal from '../../../components/eir-login/EirRegistrationRequiredModal';
import EirMetaTag from '../../../components/eir-meta-tag/EirMetaTag';
import EirHeader from '../../../components/eir-header/EirHeader';
import EirFooter from '../../../components/eir-footer/EirFooter';
import LoginMain403 from '../../../components/eir-403-login/LoginMain403';
import SessionExpireModal from '../../../components/eir-session-expire-modal/sessionExpireModal';
import NBIErrorModal from '../../../components/eir-broadband/NBIErrorModal';
import MfaOtpModal from '../../../components/eir-login/MfaOtpModal';
import MfaSuccessModal from '../../../components/eir-login/MfaSuccessModal';

const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps({ req }) {
  let cmsDataBroadband = {};
  let cmsDataMobile = {};
  let journeyData = {};
  let eligibility = {};
  let cmsHeaderData = {};
  let cmsFooterData = {};
  let error = '';

  try {
    cmsDataBroadband = await getStrapiData('broadband');
    cmsDataMobile = await getStrapiData('mobile');
    cmsHeaderData = await getStrapiData('header');
    cmsFooterData = await getStrapiData('footer');
    const cmsDataLoginBanner = await getStrapiData('notification-banner');
    // const cmsDataLoginModal = await getStrapiData('eir-login-modal');
    cmsDataBroadband.data.attributes.notificationBanner = cmsDataLoginBanner?.data?.attributes;
    // cmsDataBroadband.data.attributes.loginModal = cmsDataLoginModal?.data?.attributes;
    cmsDataBroadband = cmsDataBroadband?.data;
    journeyData = await validateCart(req.cookies);
    if (journeyData.token) {
      eligibility = await eligibilityCheck({ token: journeyData.token });
      eligibility = JSON.stringify(eligibility);
    }
  } catch (errors) {
    console.log(errors.message);
    eligibility = JSON.stringify(eligibility);
    error = errors.message;
  }
  return {
    props: {
      cmsDataBroadband,
      cmsDataMobile,
      journeyData,
      eligibility,
      cmsHeaderData,
      cmsFooterData,
      error,
    },
  };
}

const BroadbandPage = ({
  cmsDataBroadband,
  cmsDataMobile,
  eligibility,
  journeyData,
  cmsHeaderData,
  cmsFooterData,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  const [enableModal, setEnableModal] = useState(false);
  const [changeOffer, setChangeOffer] = useState(false);
  const [crossSell, setCrossSell] = useState(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [showCrossSell, setShowCrossSell] = useState(false);
  // const [skipCrossSellInitiate, setSkipCrossSellInitiate] = useState(false);
  const [COEligibilityStatus, setCOEligibilityStatus] = useState('');
  const [subscriptionId, setSubscriptionId] = useState();
  const [hideTV, setHideTV] = useState(true);
  const [hideMobile, setHideMobile] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [dualplaySubscriptions, setDualplaySubscriptions] = useState([]);
  const [currentEligibility, setCurrentEligibility] = useState({});
  const [eligibleForNone, setEligibleForNone] = useState(false);
  const [disableNotificationBanner, setDisableNotificationBanner] = useState(true);
  const [enableStepper, setEnableStepper] = useState(false);
  const [prequal, setPrequal] = useState(false);
  const [showNotEligibleModal, setShowNotEligibleModal] = useState(false);
  // const [offerCardTextVisible, setOfferCardTextVisible] = useState(false);
  const errorModal = useToggle(false);
  const openAbondonModal = useToggle(false);
  const registrationIncompleteModal = useToggle(false);
  const mfaOtpModal = useToggle(false);
  const [userValue, setUserValue] = useState('');
  const [delivery, setDelivery] = useState('');
  const mfaSuccessModal = useToggle(false);
  const isPrepayCustomer = useToggle(false);
  const errorModalMaxOccurence = 6;
  const graphql = useApolloClient();
  const theme = useTheme();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const { dispatch: rootDispatch } = useContext(RootContext);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [hideOfferCard, setHideOfferCard] = useState(
    getCookie('COMP_MAP') ? !JSON.parse(getCookie('COMP_MAP'))?.CO : false
  );
  const [hidePrequalBanner, setHidePrequalBanner] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [onLoadingDisablecta, setOnLoadingDisablecta] = useState(false);
  const [clearJourney, setClearJourney] = useState(false);
  const [journeyType, setJourneyType] = useState('');
  const [hasChangedSubs, setChangeSubs] = useState(false);
  const [dropdownContent, setDropdownContent] = useState([]);
  const [hideUpsellTV, setHideUpsellTV] = useState(false);
  const [CSFailed, setCSFailed] = useState(false);
  const [myEirTvAdd, setMyEirTvAdd] = useState(false);
  const [myEirCOAdd, setMyEirCOAdd] = useState(false);
  const [journeyCrossOver, setJourneyCrossOver] = useState(false);
  const [holdPrequal, setHoldPrequal] = useState(true);
  const enableWebChat = useToggle(false);
  const enableNBIPrevention = useToggle(false);
  const { state: rootState } = useContext(RootContext);
  const { notificationBanner, loginModal } = cmsDataBroadband.attributes;
  const [isPrequaled, setIsPrequaled] = useState(false);
  const [isPrequal, setIsPrequal] = useState(false);
  const [prequaledFromBanner, setPrequaledFromBanner] = useState(false);
  const [prequalByPhone, setPrequalByPhone] = useState(false);
  const [NEQDetails, setNEQDetails] = useState({});
  const [prequalCTALoaderText, setprequalCTALoaderText] = useState('');
  const [otpUUID, setOtpUUID] = useState('');

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
      errorModal.disable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
      errorModal.disable();
    } else {
      showSessionExpiredModal.disable();
    }
  });
  const handleOk = () => {
    setEnableModal(true);
  };

  const handleAltCta = async () => {
    if (changeOffer) return;
    try {
      const offerId = await rootState.cart?.offers?.filter(
        offer => offer.baseOffer?.serviceGroup === 'DUALPLAY'
      )[0]?.id;

      if (rootState.cart?.offers.length > 0 && offerId) {
        const data = await removeTariff(graphql, offerId);
        if (data !== null && !data.error) {
          dispatch({ type: 'SET_CART', payload: data });
          removeLocalStorage('PREQUAL_RESULT');
          localStorage.clear();
          removeLocalStorage('PREQUAL_ADDRESS');
          setIsPrequaled(false);
          setIsPrequal(false);
          setErrorModalOccurence(0);
          setPrequalByPhone(false);
          setEnableModal(false);
        }
      } else {
        removeLocalStorage('PREQUAL_RESULT');
        localStorage.clear();
        removeLocalStorage('PREQUAL_ADDRESS');
        setIsPrequaled(false);
        setIsPrequal(false);
        setErrorModalOccurence(0);
        setPrequalByPhone(false);
        setEnableModal(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const newCSJourney = async () => {};
  const defaultCSFlow = async () => {
    // let isDualplay = false;
    let isTV = false;
    let isMobile = false;
    const subscriptionIdforCS =
      getCookie('subscription_id') === '0'
        ? localStorage.getItem('CO_SUBSCRIPTIONID')
        : getCookie('subscription_id');
    // const accId = currentEligibility?.subscriptions.filter(
    //   item => item?.id === subscriptionIdforCS
    // )[0].accountId;
    const accId = getCookie('account_id');
    if (
      !subscriptionIdforCS ||
      subscriptionIdforCS === 'null' ||
      subscriptionIdforCS === 'undefined'
    )
      return;
    const { data } = await getCrossSellEligiblity({
      token: getTokenFromCookies(),
      accountId: accId,
      parentSubscriptionId: subscriptionIdforCS ? `${subscriptionIdforCS}` : null,
    });
    if (data && dualplaySubscriptions?.length <= 1) {
      setEnableModal(false);
    }
    if (data?.serviceGroups?.length === 0) setCSFailed(true);
    else setCSFailed(false);
    if (data?.serviceGroups?.length === 0) return;
    data?.serviceGroups?.map(item => {
      // if (item.serviceGroup === 'DUALPLAY' && item.eligible === true) isDualplay = true;
      if (item.serviceGroup === 'TV' && item.eligible === true) isTV = true;
      if (item.serviceGroup === 'MOBILE' && item.eligible === true) isMobile = true;
      return [];
    });
    if (!isTV && isMobile) {
      setShowCrossSell(true);
      if (getCookie('COMP_MAP')) {
        const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
        COMP_MAP.CS = true;
        COMP_MAP.CSPreCardCount = 1;
        setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
      }
      setCrossSell(true);
      // setSkipCrossSellInitiate(false);
      setHideUpsellTV(true);
      setHideTV(true);
      setHideMobile(false);
    } else if (isTV && !isMobile) {
      setShowCrossSell(true);
      if (getCookie('COMP_MAP')) {
        const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
        COMP_MAP.CS = true;
        COMP_MAP.CSPreCardCount = 1;
        setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
      }
      setCrossSell(true);
      // setSkipCrossSellInitiate(false);
      setHideMobile(true);
      setHideUpsellTV(false);
      setHideTV(false);
    } else if (isTV && isMobile) {
      if (getCookie('COMP_MAP')) {
        const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
        COMP_MAP.CS = true;
        COMP_MAP.CSPreCardCount = 2;
        setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
      }
      setHideUpsellTV(false);
      setHideTV(false);
      setHideMobile(false);
      setShowCrossSell(true);
      setCrossSell(true);
      // setSkipCrossSellInitiate(false);
    } else if (!isTV && !isMobile) {
      setShowCrossSell(false);
      setCrossSell(false);
      // setSkipCrossSellInitiate(false);
      setHideUpsellTV(true);
      setHideTV(true);
      setHideMobile(true);
      if (dualplaySubscriptions.length > 0) {
        const hasAnyOffers =
          dualplaySubscriptions.filter(
            item =>
              item.coEligiblity.contractRenewal &&
              item.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0
          ).length > 0;
        if (hasAnyOffers === false && !getCookie('CART_TYPE')) {
          enableWebChat.enable();
        } else {
          setHoldPrequal(false);
          enableWebChat.disable();
        }
      }
    }
  };
  const newCOJourney = async subscriptions => {
    const selectedSubscription = subscriptions?.filter(item => item.id === subscriptionId)[0];
    if (selectedSubscription) {
      setCookie('ION', 'selected_subscription', JSON.stringify(selectedSubscription));
      setCookie('ION', 'ECC_ADDRESS', formatAddress(selectedSubscription?.addressInfo));
    }
    if (
      Object.keys(selectedSubscription || {}).length !== 0 &&
      selectedSubscription.constructor === Object
    ) {
      const offerCode = selectedSubscription?.catalogOfferCode;
      if (offerCode.indexOf('NBI') > 0) setShowNotEligibleModal(true);
      if (
        selectedSubscription.coEligiblity.earlyCeaseChargeList?.totalAmountVatIncluded > 0 ||
        offerCode.indexOf('NBI') > 0
      ) {
        // ECC Customer ,not eligible for CHANGE OFFER
        setCookie('CO', 'subscription_ID', subscriptionId);
        if (CSFailed) {
          setOnLoadError(true);
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          setCOEligibilityStatus('ECC');
          return;
        }
        setHideOfferCard(true);
        setOnLoadError(false);
        setErrorModalOccurence(0);
        setDisableNotificationBanner(true); // Hide login modal when user selects any subscription from the dropdown
        setEnableStepper(true); //  Enable the Stepper when user selects any subscription from the dropdown
        setChangeOffer(false);
        setCOEligibilityStatus('ECC'); // ECC
        setCookie('ION', 'COMP_MAP', JSON.stringify({ CO: false, COSelected: false, CS: true }));
      } else if (
        selectedSubscription.coEligiblity?.contractRenewal &&
        selectedSubscription.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0 // Not an ECC Customer, hence eligible for CHANGE OFFER
      ) {
        setCookie('CO', 'subscription_ID', subscriptionId);
        setCode('CO');
        try {
          await changeOfferRequest({
            graphql,
            subscriptionId: subscriptionId || selectedSubscription.id,
            channel: getCookie('channel')
              ? getCookie('channel')
              : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
            email: getCookie('email_Address'),
          });
          setCookie(
            'ION',
            'COMP_MAP',
            JSON.stringify({
              CO: true,
              COSelected: false,
              CS: false,
            })
          );

          setOnLoadError(false);
          setErrorModalOccurence(0);
          setHideOfferCard(false);
          setChangeOffer(true); // change offer tariff flag, sent to offerCardContainer to show CO cards
          setDisableNotificationBanner(true); // Hide login modal when user selects any subscription from the dropdown
          setEnableStepper(true); //  Enable the Stepper when user selects any subscription from the dropdown
          setCOEligibilityStatus('E'); // ECC
        } catch (err) {
          // cross sell when change offer fails
          setHideOfferCard(true);
          setOnLoadError(false);
          setErrorModalOccurence(0);
          setDisableNotificationBanner(true); // Hide login modal when user selects any subscription from the dropdown
          setEnableStepper(true); //  Enable the Stepper when user selects any subscription from the dropdown
          setChangeOffer(false);
          setCOEligibilityStatus('ECC'); // ECC
          setCookie('ION', 'COMP_MAP', JSON.stringify({ CO: false, COSelected: false, CS: true }));
          // setOnLoadError(true);
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
        }
      } else {
        setChangeOffer(false);
      }
      return false;
    }
  };
  const existingCOJourney = async subscriptions => {
    // setShowCrossSell(true);
    // setSkipCrossSellInitiate(false);
    // if (getCookie('prequal_Id')) {
    //   // setLocalStorage('prequalid', getCookie('prequal_Id'));
    //   await getCOPrequalDetailsByID(graphql, parseInt(getCookie('prequal_Id'), 10));
    // }
    let subscriptionIdforCO = '';
    // if (typeof JSON.parse(getCookie('subscription')) === 'object') {
    subscriptionIdforCO = parseInt(getCookie('subscription_id'), 10); // test
    // }
    if (subscriptionId && subscriptionIdforCO !== subscriptionId) {
      newCOJourney(subscriptions);
    } else {
      setSubscriptionId(subscriptionIdforCO);
      const selectedSubscription = subscriptions?.filter(
        item => item.id === subscriptionIdforCO
      )[0];
      if (
        Object.keys(selectedSubscription || {}).length !== 0 &&
        selectedSubscription.constructor === Object
      ) {
        setCookie('ION', 'ECC_ADDRESS', formatAddress(selectedSubscription?.addressInfo));
        if (selectedSubscription.coEligiblity?.contractRenewal === true) {
          setCode('CO');
          setChangeOffer(true); // setting change offer flag to true, for showing CO cards
          setDisableNotificationBanner(true); // Hide login modal when user selects any subscription from the dropdown
          setEnableStepper(true); //  Enable the Stepper when user selects any subscription from the dropdown

          const offerCode = selectedSubscription?.catalogOfferCode;
          if (offerCode.indexOf('NBI') > 0) setShowNotEligibleModal(true);
          if (
            selectedSubscription.coEligiblity.earlyCeaseChargeList?.totalAmountVatIncluded > 0 ||
            offerCode.indexOf('NBI') > 0
          )
            setCOEligibilityStatus('ECC');
          else setCOEligibilityStatus('E');
        } else if (selectedSubscription.coEligiblity?.contractRenewal === false) {
          setCOEligibilityStatus('NE'); // not elligible
        } else {
          setChangeOffer(false);
          setShowCrossSell(false);
        }
      }
    }
  };

  const notEligibleForDualplay = dualSubs => {
    const notEligibleForDualPlay = dualSubs.filter(
      dualSub => dualSub.coEligiblity?.contractRenewal !== false || null
    );

    if (dualSubs.length === 0) {
      setChangeOffer(false);
      return;
    }
    if (notEligibleForDualPlay.length === 0) {
      setEligibleForNone(true);
      setShowNotEligibleModal(true);
      setShowSubscriptionModal(false); // needs to be tested in test03
      // setCOEligibilityStatus('NE');
      setChangeOffer(false);
      // setShowSubscriptionModal(false);
    } else {
      setEligibleForNone(false);
      setShowNotEligibleModal(false);
      // setCOEligibilityStatus('E');
      setChangeOffer(false);
      // setShowSubscriptionModal(true);
    }
  };
  const fillDropdown = dualplaySubscription => {
    const subscriptionIds = [];
    dualplaySubscription.map(subscription =>
      subscriptionIds.push({
        value: subscription.id,
        label: subscription.id,
        addressInfo: formatAddress(
          subscription?.addressInfo,
          subscription?.servicesForSubscription
        ),
        changeOffer: subscription?.coEligiblity?.contractRenewal,
        totalAmountVatIncluded: subscription?.coEligiblity?.totalAmountVatIncluded,
      })
    );
    setDropdownContent(subscriptionIds);
    // filter out subscriptions which has changeOffer either false or null
    const noChangeOfferSubs = subscriptionIds.filter(
      dualSub => dualSub.changeOffer !== false || null
    );
    if (noChangeOfferSubs.length === 0) {
      setEnableStepper(false);
    } else {
      setEnableStepper(true);
    }
    setDisableNotificationBanner(true);
  };
  const onload = async () => {
    // 1st case: upon login

    const operationData = await validateCart(getAllCookies());
    const subs = getCookie('reference') ? getCookie('selected_subscription') : null;

    let subscriptionIdforCO = '';
    let Eligibility = eligibility;

    subscriptionIdforCO = subs && JSON.parse(subs)?.id;

    Eligibility = eligibility.constructor !== Object ? JSON.parse(eligibility) : eligibility;
    setCurrentEligibility(Eligibility);

    if (Eligibility.subscriptions) {
      if (
        Eligibility.subscriptions?.filter(item => item.serviceGroup === 'DUALPLAY').length === 0 &&
        !getCookie('cart_type')
      ) {
        enableWebChat.enable();
      }
    }
    if (
      Object.keys(Eligibility).length === 0 &&
      Object.keys(currentEligibility).length === 0 &&
      Eligibility.constructor === Object
    ) {
      if (operationData?.isToken) {
        const tempEligibility = await eligibilityCheck({ token: operationData.token });
        if ((subscriptionId && subscriptionId !== subscriptionIdforCO) || !subscriptionId) {
          try {
            if (tempEligibility.subscriptions) {
              if (
                tempEligibility.subscriptions?.filter(item => item.serviceGroup === 'DUALPLAY')
                  .length === 0 &&
                !getCookie('cart_type')
              ) {
                enableWebChat.enable();
              }
            }
            if (getCookie('subscription_id')) {
              const subscription = tempEligibility?.subscriptions?.filter(
                item => item.id === parseInt(getCookie('subscription_id'), 10)
              )[0];
              if (subscription)
                setCookie('ION', 'selected_subscription', JSON.stringify(subscription));
            }
            const tempDualplaySubscriptions =
              tempEligibility?.subscriptions?.filter(
                subscription => subscription.serviceGroup === 'DUALPLAY'
              ) || [];
            // if (tempDualplaySubscriptions.length === 0 && !getCookie('CART_TYPE')) {
            //   enableWebChat.enable();
            // }
            if (tempEligibility.subscriptions === undefined) {
              setOnLoadError(true);
              if (!getCookie('token-missing') && !getCookie('found-403'))
                setErrorModalOccurence(errorModalOccurence + 1);
              if (!getCookie('found-403')) errorModal.enable();
              if (!getCookie('token-missing')) errorModal.enable();
              return;
            }
            setDualplaySubscriptions(tempDualplaySubscriptions);
            fillDropdown(tempDualplaySubscriptions);
            setCurrentEligibility(tempEligibility);
            notEligibleForDualplay(tempDualplaySubscriptions);
            if (tempDualplaySubscriptions?.length > 1) {
              if (setOnLoadingDisablecta) setOnLoadingDisablecta(false);
              // setShowLoader(false);
              setEnableModal(false);
            }
          } catch (err) {
            if (!getCookie('found-403')) errorModal.enable();
            if (!getCookie('token-missing')) errorModal.enable();
            if (setOnLoadingDisablecta) setOnLoadingDisablecta(false);
            setShowLoader(false);
            setEnableModal(true);
          }
        }
        if (Object.keys(tempEligibility || {}).length === 0 && !getCookie('cart_type')) {
          enableWebChat.enable();
        }
      }
    } else {
      // on load: when refreshed
      const cEligibility = Object.keys(Eligibility).length !== 0 ? Eligibility : currentEligibility;
      if (cEligibility.subscriptions) {
        if (
          cEligibility.subscriptions?.filter(item => item.serviceGroup === 'DUALPLAY').length ===
            0 &&
          !getCookie('cart_type')
        ) {
          enableWebChat.enable();
        }
      }
      if (Object.keys(cEligibility || {}).length === 0 && !getCookie('cart_type')) {
        enableWebChat.enable();
      }
      if (getCookie('subscription_id')) {
        const subscription = cEligibility?.subscriptions?.filter(
          item => item.id === parseInt(getCookie('subscription_id'), 10)
        )[0];
        if (subscription) setCookie('ION', 'selected_subscription', JSON.stringify(subscription));
      }
      const tempDualplaySubscriptions =
        cEligibility?.subscriptions?.filter(
          subscription => subscription.serviceGroup === 'DUALPLAY'
        ) || [];
      // handling error for missing data
      // if (tempDualplaySubscriptions.length === 0 && !getCookie('CART_TYPE')) {
      //   enableWebChat.enable();
      // }
      if (cEligibility.subscriptions === undefined) {
        setOnLoadError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        return;
      }
      fillDropdown(tempDualplaySubscriptions);
      setDualplaySubscriptions(tempDualplaySubscriptions);
      setCurrentEligibility(cEligibility);
      notEligibleForDualplay(tempDualplaySubscriptions);
    }

    try {
      // if cart has no reference
      if (!operationData.reference) {
        if (!operationData.isToken) return;
        if (operationData.isToken && !operationData.validToken) setEnableModal(true);
        else if (operationData.isToken && operationData.validToken) {
          if (!subscriptionId) {
            setShowSubscriptionModal(true);
          }
          setOnLoadError(false);
          setErrorModalOccurence(0);
          await newCOJourney(currentEligibility?.subscriptions);
          await defaultCSFlow();
        }
      }
      // if cart has reference
      if (operationData.reference) {
        if (operationData?.isToken && !operationData?.validToken) setEnableModal(true);
        if (!operationData?.isToken && operationData.cartType !== 'NEW_ACQUISITION')
          setEnableModal(true);
        // case 3
        if (operationData.cartType === 'CROSS_SELL' && operationData?.isToken) {
          setSubscriptionId(JSON.parse(subs)?.id || parseInt(getCookie('subscription_id'), 10)); // temporary
          setShowSubscriptionModal(false);
          if (CSFailed) {
            setOnLoadError(true);
            if (!getCookie('token-missing') && !getCookie('found-403'))
              setErrorModalOccurence(errorModalOccurence + 1);
            if (!getCookie('found-403')) errorModal.enable();
            if (!getCookie('token-missing')) errorModal.enable();
            setShowLoader(false);
            setEnableModal(false);
            return;
          } // temporary
          setErrorModalOccurence(0);
          if (getCookie('CHANNEL') !== 'MYEIR') {
            if (
              getCookie('selected_subscription') &&
              typeof JSON.parse(getCookie('selected_subscription')) === 'object' &&
              JSON.parse(getCookie('selected_subscription')).coEligiblity.contractRenewal &&
              JSON.parse(getCookie('selected_subscription')).coEligiblity.earlyCeaseChargeList
                ?.totalAmountVatIncluded <= 0
              // Eligible for CHANGE_OFFER
            ) {
              setCOEligibilityStatus('E');
              setShowCrossSell(true);
              setHideOfferCard(true);
              // setChangeOffer(true);
            } else {
              setCOEligibilityStatus('ECC'); // temporary
              setShowCrossSell(true); // temporary
            }
          } else {
            setLocalStorage('PROSPECTUUID', getCookie('REFERENCE'));
            setMyEirTvAdd(!myEirTvAdd);
            setHideOfferCard(true);
            setShowCrossSell(true);
            // setCrossSell(true);
            // await defaultCSFlow();
          }
          setDisableNotificationBanner(true); // temporary
          setEnableStepper(true); // temporary
          await defaultCSFlow();
          newCSJourney();
        } else if (operationData.cartType === 'CHANGE_OFFER' && operationData?.isToken) {
          if (getCookie('channel') === 'MYEIR') {
            if (!getCookie('prequal_Id')) {
              await getJourneyDetails(operationData?.reference);
            }
            if (getCookie('MYEIR_BB_ADDED') === 'true') {
              setCOEligibilityStatus('MYEIR');
              // setIsPrequaled(false);
              // setPrequal(false);
              setHideOfferCard(true);
              setShowCrossSell(false);
              setHideUpsellTV(false);
              existingCOJourney(currentEligibility?.subscriptions);
            } else {
              existingCOJourney(currentEligibility?.subscriptions);
              await defaultCSFlow();
            }
          } else {
            existingCOJourney(currentEligibility?.subscriptions);
            await defaultCSFlow();
          }
          if (getCookie('prequal_Id'))
            await getCOPrequalDetailsByID(graphql, parseInt(getCookie('prequal_Id'), 10));
        } else if (operationData.cartType === 'NEW_ACQUISITION' && operationData?.isToken) {
          setShowSubscriptionModal(true);
        }
      }
      // setShowLoader(false);
      // setEnableModal(false);
    } catch (err) {
      setOnLoadError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
    }
    // setHoldPrequal(false);
  };
  useEffect(() => {
    if (prequaledFromBanner) {
      setShowLoader(false);
      // setEnableModal(false);
    }
  }, [prequaledFromBanner]);

  useEffect(() => {
    if (getCookie('BILL_TYPE') === 'Prepay') {
      isPrepayCustomer.enable();
    }
  }, []);

  const clearJourneyDetailsOnSubscriptionChange = () => {
    setShowSubscriptionModal(false);
    setHoldPrequal(true);
    if (
      subscriptionId &&
      getCookie('subscription_id') &&
      parseInt(getCookie('subscription_id'), 10) !== parseInt(subscriptionId, 10) &&
      getCookie('CHANNEL') !== 'MYEIR'
    ) {
      try {
        setHidePrequalBanner(false);
        // setCOEligibilityStatus('ECC');
        setHoldPrequal(true);
        setIsPrequal(false);
        setIsPrequaled(false);
        removeCookie('COMP_MAP');
        // setHidePrequalBanner(false);
        setHideOfferCard(false);
        setShowCrossSell(false);
        removeCookie('selected_subscription');
        removeCookie('subscription_id');
        removeCookie('cart_Type');
        removeCookie('reference');
        // setCOEligibilityStatus('');
        clearLocalStorage();
        rootDispatch({ type: 'SET_CART', payload: null });
        displayCart({
          showCart: false,
          dispatch: rootDispatch,
        });
      } catch (err) {
        console.log(err);
      }
    }
    onload();
  };
  useEffect(() => {
    if (dualplaySubscriptions?.length > 1) fillDropdown(dualplaySubscriptions);
    if (
      dualplaySubscriptions.length === 1 &&
      dualplaySubscriptions[0].coEligiblity?.contractRenewal === true
    ) {
      setSubscriptionId(dualplaySubscriptions[0].id);
      setCookie('ION', 'ECC_ADDRESS', formatAddress(dualplaySubscriptions[0]?.addressInfo));
    } else if (
      dualplaySubscriptions.length === 1 &&
      dualplaySubscriptions[0].coEligiblity?.contractRenewal === null
    ) {
      setShowNotEligibleModal(true);
      setCOEligibilityStatus('ECC');
      setShowCrossSell(true);
      setHideOfferCard(true);
      setEligibleForNone(true);
    }
  }, [dualplaySubscriptions]);

  useEffect(() => {
    dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: false });
    if (getTokenFromCookies()?.length > 0) {
      setDisableNotificationBanner(true);
    } else setDisableNotificationBanner(false);
    if (journeyData.cartType === 'CROSS_SELL') {
      setCode('CS');
      setHideOfferCard(true);
      setHidePrequalBanner(true);
      // setCrossSell(true);
      setHoldPrequal(true);
    }
    if (journeyData.cartType === 'CHANGE_OFFER') {
      setCode('CO');
      if (getTokenFromCookies()?.length > 0) {
        dispatch({
          type: 'LOGIN',
          payload: { email: getCookie('email_Address') },
        });
      }
    }
  }, []);

  useEffect(() => {
    const cartType = getCookie('cart_Type');
    const reference = getCookie('REFERENCE');
    setJourneyType(cartType);
    const subs = getCookie('selected_subscription');

    if (cartType === 'CROSS_SELL' && reference && !subs && getCookie('CHANNEL') !== 'MYEIR') {
      setHideOfferCard(true);
      setHidePrequalBanner(true);
      openAbondonModal.enable();
      setHoldPrequal(true);
    }
    if (cartType === 'CHANGE_OFFER') {
      const selctedSubs = JSON.parse(subs);
      if (selctedSubs) {
        if (selctedSubs?.serviceGroup === 'MOBILE') {
          openAbondonModal.enable();
        }
      }
    }

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('enable') === 'true') {
      setEnableModal(true);

      // Replace the current history state with the new URL
      window.history.replaceState(null, '', window.location.pathname);
    }
    dispatch({ type: 'SET_BROADBAND', payload: cmsDataBroadband });
    onload();
    // setKeepTVSelected(true);
  }, []);
  useEffect(() => {
    clearJourneyDetailsOnSubscriptionChange();
  }, [subscriptionId]);
  useEffect(() => {
    if (journeyCrossOver) {
      rootDispatch({ type: 'SET_CART', payload: null });
      if (dualplaySubscriptions?.length > 1 && !eligibleForNone) {
        setShowSubscriptionModal(true);
      } else {
        clearJourneyDetailsOnSubscriptionChange();
      }
      setCOEligibilityStatus('');
      setHideOfferCard(false);
      setHidePrequalBanner(false);
      setIsPrequal(false);
      setIsPrequaled(false);
      setShowCrossSell(false);
      // onload();
      setJourneyCrossOver(false);
    }
  }, [journeyCrossOver]);
  useEffect(() => {
    if (getTokenFromCookies()) {
      if (changeOffer && getLocalStorage('PREQUAL_RESULT')) {
        // setHidePrequalBanner(false);
        setHideOfferCard(false);
        setHoldPrequal(false);
      } else if (
        COEligibilityStatus === 'ECC' &&
        getCookie('SUBSCRIPTION_ID') &&
        !getCookie('CART_TYPE')
      ) {
        setHideOfferCard(false);
        setHoldPrequal(false);
      } else if (getCookie('CART_TYPE') === 'CROSS_SELL') {
        setHideOfferCard(true);
        setHoldPrequal(false);
      } else setHoldPrequal(true);
    } else {
      setHoldPrequal(false);
    }
  }, [changeOffer, COEligibilityStatus, showCrossSell]);
  useEffect(() => {
    if (getCookie('PREPAY_REFERENCE')) {
      clearAllCookies();
      localStorage.clear();
    }
  }, []);
  return (
    <>
      <EirMetaTag seo={cmsDataBroadband?.attributes?.Seo_Broadband} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <BroadbandContext.Provider value={{ state, dispatch }}>
          {!disableNotificationBanner && (
            <NotificationBanner
              desktopText={
                <Typography component='p' variant='body1' color={theme.palette.primary.textColor3}>
                  <Typography
                    component='span'
                    variant='subtitle1'
                    color={theme.palette.primary.textColor3}
                  >
                    {notificationBanner.desktopDescriptionFirstHalf}
                  </Typography>{' '}
                  {notificationBanner.desktopDescriptionSecondHalf}
                </Typography>
              }
              mobileText={notificationBanner.mobileDescription}
              cta={{
                ctaText: 'Log in to see deals',
                ariaLabel: 'Log in to see deals',
                type: 'solid',
                action: () => handleOk(),
                disableCta: false,
              }}
              setEnableModal={setEnableModal}
              // logoutCta={<EirLogOut ctaText='Log out' cmsData={cmsDataBroadband} />}
            />
          )}
          {enableStepper && dropdownContent?.length > 1 && (
            <NavBar
              additionalStyles
              headerText={
                <>
                  <NavBarTitle
                    title='Which Broadband would you like to change?'
                    style={
                      !sm && {
                        title: { marginRight: '32px' },
                      }
                    }
                  />{' '}
                  <DropDownMenu
                    additionalStyles
                    setSubscriptionId={setSubscriptionId}
                    subscriptionId={subscriptionId}
                    numbers={dropdownContent}
                    setChangeSubs={setChangeSubs}
                    clearJourney={clearJourney}
                    setClearJourney={setClearJourney}
                    openAbondonModal={openAbondonModal}
                  />
                </>
              }
            />
          )}

          {showSubscriptionModal && dualplaySubscriptions?.length > 1 && !eligibleForNone && (
            <SubscriptionSelectionModal
              titleName={currentEligibility?.contactDetails?.firstName}
              disableAltcta
              subscriptions={dualplaySubscriptions}
              setSubscriptionId={setSubscriptionId}
              openAbondonModal={openAbondonModal}
              clearJourney={clearJourney}
              setClearJourney={setClearJourney}
              setChangeSubs={setChangeSubs}
            />
          )}
          {enableModal && (
            <LoginModal
              enable={enableModal}
              setEnableModal={setEnableModal}
              registrationIncompleteModal={registrationIncompleteModal}
              mfaOtpModal={mfaOtpModal}
              setUserValue={setUserValue}
              setDelivery={setDelivery}
              mfaSuccessModal={mfaSuccessModal}
              setOtpUUID={setOtpUUID}
              cmsData={loginModal}
              prequal={prequal}
              handleAltCta={handleAltCta}
              onload={onload}
              setShowSubscriptionModal={setShowSubscriptionModal}
              saveLoginInfo={dispatch}
              showLoader={showLoader}
              setShowLoader={setShowLoader}
              loaderText='logging in'
              onLoadingDisablecta={onLoadingDisablecta}
              setOnLoadingDisablecta={setOnLoadingDisablecta}
              prequaledFromBanner={prequaledFromBanner}
              enableCloseCTA={prequal}
              isPrepayCustomer={isPrepayCustomer}
            />
          )}
          {mfaOtpModal.value && (
            <MfaOtpModal
              mfaOtpModal={mfaOtpModal}
              userValue={userValue}
              delivery={delivery}
              errorModal={errorModal}
              otpUUID={otpUUID}
              setOtpUUID={setOtpUUID}
              mfaSuccessModal={mfaSuccessModal}
            />
          )}
          {mfaSuccessModal.value && <MfaSuccessModal mfaSuccessModal={mfaSuccessModal} />}
          {registrationIncompleteModal.value && (
            <EirRegistrationRequiredModal
              registrationIncompleteModal={registrationIncompleteModal}
            />
          )}
          <BroadbandContainer
            cmsData={cmsDataBroadband}
            cmsDataMobile={cmsDataMobile.data}
            setPrequal={setPrequal}
            changeOffer={changeOffer}
            showCrossSell={showCrossSell}
            crossSell={crossSell}
            // skipCrossSellInitiate={skipCrossSellInitiate}
            skipCrossSellInitiate
            COEligibilityStatus={COEligibilityStatus}
            hideTV={hideTV}
            hideMobile={hideMobile}
            // offerCardTextVisible={offerCardTextVisible}
            enable={enableModal}
            setEnableModal={setEnableModal}
            // eligibleForNone={eligibleForNone}
            setClearJourney={setClearJourney}
            setShowCrossSell={setShowCrossSell}
            hidePrequalBanner={hidePrequalBanner}
            hideOfferCard={hideOfferCard}
            subscriptionId={subscriptionId}
            hideUpsellTV={hideUpsellTV}
            CSFailed={CSFailed}
            myEirTvAdd={myEirTvAdd}
            setMyEirTvAdd={setMyEirTvAdd}
            myEirCOAdd={myEirCOAdd}
            setMyEirCOAdd={setMyEirCOAdd}
            key={changeOffer}
            isPrequaled={isPrequaled}
            setIsPrequaled={setIsPrequaled}
            isPrequal={isPrequal}
            setIsPrequal={setIsPrequal}
            prequalByPhone={prequalByPhone}
            setPrequalByPhone={setPrequalByPhone}
            subscriptions={dualplaySubscriptions}
            setPrequaledFromBanner={setPrequaledFromBanner}
            eligibleForCO={!eligibleForNone}
            holdCS={openAbondonModal.value}
            clearJourneyDetailsOnSubscriptionChange={clearJourneyDetailsOnSubscriptionChange}
            holdPrequal={holdPrequal}
            setNEQDetails={setNEQDetails}
            NEQDetails={NEQDetails}
            enableNBIPrevention={enableNBIPrevention}
            setprequalCTALoaderText={setprequalCTALoaderText}
            prequalCTALoaderText={prequalCTALoaderText}
          />
          {showModal.value && <LoginMain403 />}
          {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
            <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
          )}
          {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
            <ErrorModal
              errorBBModal={errorModal}
              occurences={errorModalMaxOccurence}
              currentOccurence={errorModalOccurence}
              ctaMethod={onLoadError ? onload : () => {}}
            />
          )}
          {showNotEligibleModal && (
            <NoEligibilityErrorModal
              eligibleForNone={showNotEligibleModal}
              setEligibleForNone={setShowNotEligibleModal}
              setShowSubscriptionModal={setShowSubscriptionModal}
              setEnableModal={setEnableModal}
              dualplaySubscriptions={dualplaySubscriptions}
              defaultCSFlow={defaultCSFlow}
            />
          )}
          {openAbondonModal.value && (
            <EirAbondonJourney
              openAbondonModal={openAbondonModal}
              setClearJourney={setClearJourney}
              setJourneyCrossOver={setJourneyCrossOver}
              journeyType={journeyType}
              hasChangedSubs={hasChangedSubs}
            />
          )}
          {mfaOtpModal.value
            ? mfaSuccessModal.value &&
              !isPrepayCustomer.value &&
              enableWebChat.value && <EirWebchatModal enableWebChat={enableWebChat} />
            : !isPrepayCustomer.value &&
              enableWebChat.value && <EirWebchatModal enableWebChat={enableWebChat} />}
          {mfaOtpModal.value
            ? mfaSuccessModal.value &&
              isPrepayCustomer.value && (
                <EirPrepayModal
                  enableWebChat={isPrepayCustomer}
                  setEnableModal={setEnableModal}
                  errorModal={errorModal}
                  setShowLoader={setShowLoader}
                  setOnLoadingDisablecta={setOnLoadingDisablecta}
                />
              )
            : isPrepayCustomer.value && (
                <EirPrepayModal
                  enableWebChat={isPrepayCustomer}
                  setEnableModal={setEnableModal}
                  errorModal={errorModal}
                  setShowLoader={setShowLoader}
                  setOnLoadingDisablecta={setOnLoadingDisablecta}
                />
              )}
          {/* TBU Enable this modal based on NEQResult */}
          {enableNBIPrevention.value && (
            <NBIErrorModal enableNBIPrevention={enableNBIPrevention} NEQDetails={NEQDetails} />
          )}
        </BroadbandContext.Provider>
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </>
  );
};

export default BroadbandPage;
